import React, { MouseEvent, useReducer } from 'react';

import Button from 'components/button/button';
import FormattedMessage from 'components/formatted-message';
import { DownloadIcon } from 'components/svg-icons/playlist-icons';
import { productToPath } from 'containers/product-initializer/products';
import { scoutEvaluationTemplateIndex } from 'pages/game-center/scout/player-page/player-evaluation/scout-evaluation-template';

import CustomizationEvaluationPopup from '../../../customization-evaluation-popup';
import styles from '../profile.module.css';
import { RatingSystemSelector } from '../togglers';

// The scout rating system and evaluation settings are hidden for now (minimal mode), and so is adding a client game
const IS_MINIMAL_MODE = true;
const IS_VISIBLE_UPLOADS = false;

type ScoutProfileControlsProps = {
    isScout: boolean;
    switchRatingSystem?: (ratingSystem: unknown) => void;
    ratingSystem?: unknown;
    handleUploadClientGameClick?: (event: MouseEvent<HTMLAnchorElement>) => void;
};

const downloadEvaluationTemplate = () => {
    window.open(`${productToPath.SCOUT.path}/${scoutEvaluationTemplateIndex}`);
};

/** The profile settings shown behind the flags above: the scout rating and evaluation, adding a client game */
const ScoutProfileControls = ({
    isScout,
    switchRatingSystem,
    ratingSystem,
    handleUploadClientGameClick
}: ScoutProfileControlsProps) => {
    const [customizationPopupOpened, toggleCustomizationPopup] = useReducer((opened: boolean) => !opened, false);
    const isScoutSettingsVisible = isScout && !IS_MINIMAL_MODE;

    return (
        <>
            {isScoutSettingsVisible ? (
                <div className={styles.profileProp}>
                    <span className={styles.propTitle}>
                        <FormattedMessage id="appContainer.profile.ratingSystem" />
                    </span>
                    <RatingSystemSelector switchRatingSystem={switchRatingSystem} ratingSystem={ratingSystem} />
                </div>
            ) : null}
            {isScoutSettingsVisible ? (
                <div className={styles.profileProp}>
                    <span className={styles.propTitle}>
                        <FormattedMessage id="appContainer.profile.evaluation" />
                    </span>
                    <Button className={styles.customizationButton} onClick={toggleCustomizationPopup}>
                        <FormattedMessage id="appContainer.profile.customization" />
                    </Button>
                    <span className={styles.downloadIcon}>
                        <DownloadIcon color="var(--uiPrimaryColorActive)" onClick={downloadEvaluationTemplate} />
                    </span>
                </div>
            ) : null}
            {customizationPopupOpened ? <CustomizationEvaluationPopup /> : null}
            {IS_VISIBLE_UPLOADS ? (
                <div className={styles.uploadClientGameButton}>
                    <a href="#upload-client-game" onClick={handleUploadClientGameClick}>
                        <FormattedMessage id="appContainer.profile.addGame" />
                    </a>
                </div>
            ) : null}
        </>
    );
};

export default ScoutProfileControls;
